import styled from "@emotion/styled";

import { fontRobotoCondensed } from "shared/lib/styles";

import ArrowRightIcon from "./icon-arrow-right.svg";
import FillEmailIcon from "./icon-fill-email.svg";

export const FindOutMoreContainer = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;

  color: #ffffff;
  font-weight: 700;
  font-size: 14px;
  font-family: ${fontRobotoCondensed};
  text-transform: uppercase;
`;

export const SignUpLinkContainer = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;

  color: #2c4692;
  font-weight: 700;
  font-size: 14px;
  font-family: ${fontRobotoCondensed};
`;

export const StyledFillEmailIcon = styled(FillEmailIcon)``;

export const StyledArrowRightIcon = styled(ArrowRightIcon)`
  inline-size: 25px;
  block-size: 8px;
`;
